import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getFuels from '../../services/fuel/getFuels'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchFuelCombo ({ includeDeleted }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const fuelCombo = yield call(getFuels, auth.token, includeDeleted)
    yield put(fetchCombosSuccess({ fuelCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchFuelCombo () {
  yield takeLatest(combosActionTypes.FETCH_FUEL_COMBO, fetchFuelCombo)
}
